<template>
  <div>
    <!-- 店长端 -->
    <img
      :src="prefixURL + 'appLark.png'"
      alt=""
      class="recruit"
    >
    <van-button
      class="apply"
      text="立即申请"
      block
      to="applyPublishers"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
.recruit {
  width: 100%;
  height: 100%;
  display: block;
}
.apply {
  width: 243px;
  height: 45px;
  padding: 0;
  position: fixed;
  left: 66px;
  bottom: 50px;
  font-size: 18px;
  color: #ffffff;
  background-color: #5332A0;
  border-width: 0 !important;
  border-radius: 50px;
}
</style>